// 导入axios实例
import httpRequest from '@/utils/request'

export function getSaasConfig(data) {
    return httpRequest({
        url: '/system/get_saas_config',
        method: 'get',
        data,
    })
}

// 获取用户信息
export function expressApi(data) {
    return httpRequest({
        url: '/system/express_api',
        method: 'post',
        data,
    })
}

//创建角色
export function roleSave(data) {
    return httpRequest({
        url: '/system/role_save',
        method: 'post',
        data,
    })
}

//删除角色
export function roleDel(data) {
    return httpRequest({
        url: '/system/role_del',
        method: 'post',
        data,
    })
}

//设置角色权限
export function roleAuth(data) {
    return httpRequest({
        url: '/system/role_auth',
        method: 'post',
        data,
    })
}

//获取已有角色
export function roleInfo(params) {
    return httpRequest({
        url: '/system/role_info',
        method: 'GET',
        params,
    })
}

//获取菜单
export function systemMenu(params,headers) {
    return httpRequest({
        url: '/system/menu',
        method: 'get',
        params,
        headers
    })
}

export function roleList(data) {
    return httpRequest({
        url: '/system/role_list',
        method: 'get',
        data,
    })
}

export function subAccountAdd(data) {
    return httpRequest({
        url: '/user/sub_account_add',
        method: 'post',
        data,
    })
}

export function subAccountSave(data) {
    return httpRequest({
        url: '/user/sub_account_save',
        method: 'post',
        data,
    })
}

export function distributionSave(data) {
    return httpRequest({
        url: '/user/distribution_save',
        method: 'post',
        data,
    })
}

export function contentList(params) {
    return httpRequest({
        url: '/system/content_list',
        method: 'get',
        params,
    })
}

export function contentDetail(params) {
    return httpRequest({
        url: '/system/content_detail',
        method: 'get',
        params,
    })
}


export function transactiontype(params) {
    return httpRequest({
        url: '/com/transaction_type',
        method: 'get',
        params,
    })
}

export function sendAddressList(params) {
    return httpRequest({
        url: '/system/send_address_list',
        method: 'get',
        params,
    })
}


export function sendAddressSave(data) {
    return httpRequest({
        url: '/system/send_address_save',
        method: 'post',
        data,
    })
}

export function requirementsSave(data) {
    return httpRequest({
        url: '/system/requirements_save',
        method: 'post',
        data,
    })
}

export function requirementsRemarkSave(data) {
    return httpRequest({
        url: '/system/requirements_remark_save',
        method: 'post',
        data,
    })
}

export function requirementsRemarkList(params) {
    return httpRequest({
        url: '/system/requirements_remark_list',
        method: 'get',
        params,
    })
}

export function requirementsUpdateStatus(data) {
    return httpRequest({
        url: '/system/requirements_update_status',
        method: 'post',
        data,
    })
}

export function noticeList(params) {
    return httpRequest({
        url: '/system/notice_list',
        method: 'get',
        params,
    })
}

export function messageMarkRead(data) {
    return httpRequest({
        url: '/system/message_mark_read',
        method: 'post',
        data,
    })
}

export function getMessageSetting(params) {
    return httpRequest({
        url: '/system/get_message_setting',
        method: 'get',
        params,
    })
}

export function setMessageSetting(data) {
    return httpRequest({
        url: '/system/set_message_setting',
        method: 'post',
        data,
    })
}

export function noticeTypeList(params) {
    return httpRequest({
        url: '/system/notice_type_list',
        method: 'get',
        params,
    })
}

export function openLanguageList(params) {
    return httpRequest({
        url: '/system/open_language_list',
        method: 'get',
        params,
    })
}